<script setup lang="ts">
import { computed, type PropType } from 'vue'
import type { FileDTO } from '@/composables/media/media'
import { getDefaultAvatarId } from '@/utils/config'
import type { WechatUserInfo } from '@/composables/user/users'
import defaultAvatar from '@/assets/default_avatar.jpg'

const props = defineProps({
  avatar: {
    type: Object as PropType<FileDTO | null>,
    default: null
  },
  wechatInfo: {
    type: Object as PropType<WechatUserInfo | null>,
    default: null
  },
  circle: {
    type: Boolean,
    default: false
  },
  size: {
    type: Number,
    default: 7
  }
})

const avatarRef = computed(() => {
  return props.avatar?.id === getDefaultAvatarId()
    ? props.wechatInfo?.wechatAvatar || props.avatar?.lowQuality || defaultAvatar
    : props.avatar?.lowQuality || props.wechatInfo?.wechatAvatar || defaultAvatar
})

const isCircle = computed(() => props.circle)
</script>
<template>
  <div :class="`w-${size} h-${size}`" rounded overflow-hidden>
    <RLazyImage :rounded="isCircle" :src="avatarRef" :errorImg="defaultAvatar" :aspectRatio="1" />
  </div>
</template>
